export const ProfileSolidIcon = ({width='21', height='24'}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 21 24" fill="none">
            <path d="M10.5 12C8.34375 12 6.375 10.875 5.29688 9C4.21875 7.17188 4.21875 4.875 5.29688 3C6.375 1.17188 8.34375 0 10.5 0C12.6094 0 14.5781 1.17188 15.6562 3C16.7344 4.875 16.7344 7.17188 15.6562 9C14.5781 10.875 12.6094 12 10.5 12ZM8.34375 14.25H12.6094C17.25 14.25 21 18 21 22.6406C21 23.3906 20.3438 24 19.5938 24H1.35938C0.609375 24 0 23.3906 0 22.6406C0 18 3.70312 14.25 8.34375 14.25Z" fill="#1B1B20" />
        </svg>
    )
}